import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicLugardTerraces from "../Components/ProjPicLugardTerraces";

const ProjectPageLugardTerraces = () => {
    return (
        <>
            <Navbar />
            <ProjPicLugardTerraces />
            <Footer />
        </>
    );
};

export default ProjectPageLugardTerraces;
